import ReactGA from "react-ga4";

export function installGoogleAnalytics() {
  const googleAnalyticsTag = "G-F0FSC7CX95";
  const testMode =
    window.location.host === "localhost:5175" ||
    window.location.host === "127.0.0.1:5175";

  if (import.meta.env.DEV) {
    console.log(
      "ReactGA",
      testMode ? "im Testmodus" : "",
      "initialisiert (installGoogleAnalytics Hook)"
    );
  }

  // Initialize Google Analytics 4
  ReactGA.initialize(googleAnalyticsTag, {
    testMode: testMode,
  });

  // Track page view
  ReactGA.send({ hitType: "pageview", page: window.location.pathname });

  // Track cookie consent event
  ReactGA.event({
    category: "Cookie OptIn",
    action: "Cookies Zustimmung erhalten",
    label: "Zustimmung",
  });
}
